<template>
    <AppLayout>
        <ProductsLayout :products="products" :categories="categories" :sort-options="sortOptions">
            <template #content>
                <div class="bg-white">
                    <div class="mx-auto max-w-2xl px-4 py-8 sm:px-6 sm:py-16 lg:max-w-7xl lg:px-8">
                        <h2 class="sr-only">Products</h2>

                        <div
                            class="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 xl:gap-x-8">
                            <a v-for="product in products" :key="product.id" :href="`/courses/${product.slug}`"
                                class="group">
                                <img :src="product.image" :alt="product.imageAlt"
                                    class="aspect-square w-full rounded-xl bg-ink-200 object-cover group-hover:opacity-75 xl:aspect-7/8" />
                                <h3 class="mt-4 text-sm text-ink-700 font-bold">{{ product.name }}</h3>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
        </ProductsLayout>
    </AppLayout>
</template>

<script setup>

import AppLayout from '@/components/layouts/AppLayout.vue';
import ProductsLayout from '@/components/layouts/ProductsLayout.vue';

const props = defineProps({
    products: {
        type: Array,
        default: () => []
    }
});

import { ref, watchEffect } from 'vue'
import { onMounted } from 'vue';
import { getCategories } from '@/services/categoryService';
import { getProducts } from '@/services/productService';
import { useRouter } from 'vue-router';

const router = useRouter();
const categories = ref([]);
const products = ref([]);
const sortOptions = [
    { name: 'Most Popular', href: '#', current: true },
    { name: 'Best Rating', href: '#', current: false },
    { name: 'Newest', href: '#', current: false },
]

const query = router.currentRoute.value.query;

const fetchCategories = async () => {
    await getCategories()
        .then(data => {
            categories.value = data.data.map(category => {
                return {
                    name: category.name,
                    href: `/courses?category=${category.slug}`,
                }
            });
        })
        .catch(error => {
            // console.error('Error fetching categories:', error);
        });
}

const fetchProducts = async () => {
    await getProducts()
        .then(data => {
            products.value = data.data;
            console.log('Fetched Products:', data.data);
        })
        .catch(error => {
            // console.error('Error fetching products:', error);
        });
}


onMounted(() => {
    fetchCategories();
    fetchProducts();
});

watchEffect(() => {
    if (query.category) {
        products.value = products.value.filter(product => {
            return product.category && product.category.slug === query.category;
        });
    }
});

const mobileFiltersOpen = ref(false)

</script>
